import React from 'react';
import PropTypes from 'prop-types';
import { CccisdSelect } from 'cccisd-formik';
import { connect, useDispatch } from 'react-redux';
import { updateGroup } from 'js/reducers/reportFilters.js';

const GroupSelect = props => {
    const dispatch = useDispatch();

    return (
        <CccisdSelect
            field={props.field}
            form={props.form}
            options={props.groupList}
            label="Groups"
            onChange={e => {
                props.form.handleChange(e);
                dispatch(updateGroup(+e.target.value));
            }}
        />
    );
};

GroupSelect.propTypes = {
    form: PropTypes.object,
    field: PropTypes.object,
    // from redux
    groupList: PropTypes.array,
};
const mapStateToProps = state => ({
    groupList: state.app.reportFilters.groupList,
});

export default connect(mapStateToProps, { updateGroup })(GroupSelect);
